import { Notification } from "@/apollo/types";
import { useRemoveNotification } from "@/features/notifications";
import { useCallback } from "react";

export const useRetryNotification = (options?: {
  onCompleted?: (message: string) => void;
  onError?: (message: string) => void;
}) => {
  const [removeNotification, removing] = useRemoveNotification({
    onCompleted: () => options?.onCompleted?.("Sync will be retried."),
    onError: () =>
      options?.onError?.("An error occurred while queueing the sync for retry"),
  });

  const handleRetry = useCallback(
    (notification: Notification) => {
      removeNotification(notification);
    },
    [removeNotification],
  );

  return { retry: handleRetry, loading: removing };
};
